import { GlobalModal } from "./GlobalModal"

export default GlobalModal